<template>
  <b-modal
    id="searchModal"
    v-model="showModal"
    title="Search"
    hide-footer
    scrollable
    :size="modalSize"
  >
    <b-form-group :label="searchString">
      <b-input v-model="search" />
    </b-form-group>
    <b-row>
      <b-col v-if="showMap && enableSearchByLocation" cols="12" :lg="colsLg">
        <LocationSuggestionList :search="search" />
      </b-col>
      <b-col v-if="enableSearchForProjects" cols="12" :lg="colsLg">
        <ProjectSuggestionList :search="search" />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import ProjectSuggestionList from '@/components/public/Suggestions/ProjectSuggestionList.vue'
import LocationSuggestionList from '@/components/public/Suggestions/LocationSuggestionList.vue'
import { SEARCH_CONFIG_KEY } from '@/constants'

const components = {
  ProjectSuggestionList,
  LocationSuggestionList,
}

@Component({ components })
export default class SearchModal extends Vue {
  get showModal() {
    return this.$typedStore.public.search.showModal
  }

  set showModal(value) {
    this.$typedStore.public.search.setShowModal(value)
  }

  get search() {
    return this.$typedStore.public.search.searchString
  }

  set search(newValue) {
    this.$typedStore.public.search.setSearchString(newValue)
  }

  get enableSearchByLocation() {
    return (
      SEARCH_CONFIG_KEY in this.$typedStore.activeVisualisation.visualisationStore.app.config &&
      this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY]
        .enableSearchByLocation
    )
  }

  get enableSearchForProjects() {
    return (
      SEARCH_CONFIG_KEY in this.$typedStore.activeVisualisation.visualisationStore.app.config &&
      this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY]
        .enableSearchForProjects
    )
  }

  get showMap() {
    return this.$typedStore.visualisationApp.showMap
  }

  get twoPanels() {
    return this.showMap && this.enableSearchByLocation && this.enableSearchForProjects
  }

  get modalSize() {
    return this.twoPanels ? 'xl' : 'md'
  }

  get searchString() {
    if (this.twoPanels) return 'Enter your location or search for a specific keyword:'
    else if (this.enableSearchForProjects) return 'Search for a specific keyword:'
    else return 'Enter your location:'
  }

  get colsLg() {
    return this.twoPanels ? 6 : 12
  }
}
</script>
